type Props = Readonly<{
  videoId: string;
}>;

export function YouTube({ videoId }: Props): JSX.Element {
  return (
    <div className="mt-8 overflow-clip round border border-primary">
      <div className="youtube">
        <iframe
          data-testid="youtube"
          title={`youTube-${videoId}`}
          src={`https://www.youtube.com/embed/${videoId}?color=white&rel=0`}
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute top-0 left-0 w-full h-full border-none"
        ></iframe>
      </div>
    </div>
  );
}
